exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vdp-datepicker__calendar.inline {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: none !important;\n  position: static;\n  display: block;\n}\n.picker-view {\n  background-color: #fff;\n  border-radius: .25rem;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted,\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted,\n.vdp-datepicker__calendar .cell.selected {\n  background: inherit;\n}\n.highlighted {\n  background: #cae5ed !important;\n}\n", ""]);

// exports
